import React from 'react'
import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary-500">404</h1>
          <h2 className="text-2xl font-semibold text-gray-900 mt-4">
            Página no encontrada
          </h2>
          <p className="text-gray-600 mt-2">
            Lo sentimos, la página que buscas no existe.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link 
            to="/" 
            className="btn-primary inline-flex items-center"
          >
            <Home className="h-4 w-4 mr-2" />
            Volver al Inicio
          </Link>
          
          <button 
            onClick={() => window.history.back()}
            className="btn-outline inline-flex items-center ml-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Regresar
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage